import { provideEffects } from '@ngrx/effects';

import { BetslipHost } from '../core/external-betslip-actions';
import { BetslipDigitalModuleLoaderService } from './betslip-digital-module-loader.service';
import { ExternalBetslipEffects } from './external-betslip-effects';
import { BETSLIP_MODULE_LOADER_SERVICE } from './sports-injection-services';

export function provideDigitalBetslipExternal() {
    return [provideEffects([ExternalBetslipEffects])];
}

export function provideDigitalBetslipIntegration() {
    return [
        { provide: BetslipHost, useValue: BetslipHost.Digital },
        { provide: BETSLIP_MODULE_LOADER_SERVICE, useClass: BetslipDigitalModuleLoaderService },
    ];
}
